// extracted by mini-css-extract-plugin
export default {"title":"order-links-modal_title__rhJ12","buttonHidden":"order-links-modal_buttonHidden__bExt7"};